
export type HealthCheck200 = {
  service?: string;
  status?: string;
  timestamp?: string;
};
